'use strict';

var FileUploader = require('./FileUploader'),
    UserStore = require('../stores/UserStore'),
    request = require('superagent'),
    config = require('config');

var uploaderBaseUrl = config.uploaderBaseUrl;
if (!uploaderBaseUrl) {
  throw new Error('You forgot to pass uploaderBaseUrl as config parameter.');
}

var urlUploaderBaseUrl = config.urlUploaderBaseUrl;
if (!urlUploaderBaseUrl) {
  throw new Error('You forgot to pass urlUploaderBaseUrl as config parameter.');
}

function rgbToHex(rgb) {
  /*jshint bitwise: false*/
  return ((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).substr(1);
}

function toImage(uploadResult) {
  if (!uploadResult.url) {
    throw {
      description: 'The file you tried to upload is a type we don’t understand.\nSupported formats are JPEG, PNG and GIF.'
    };
  }

  return {
    type: 'image',
    url: uploadResult.url,
    size: uploadResult.size,
    colors: {
      top: rgbToHex(uploadResult.colors.top),
      bottom: rgbToHex(uploadResult.colors.bottom)
    }
  };
}

function getUploaderData() {
  return {
    'user_id': UserStore.getMe().id
  };
}

function createFileUploader() {
  return new FileUploader({
    uploadUrl: uploaderBaseUrl,
    key: 'image',
    transform: toImage,
    maxSimultaneousUploads: 4,
    data: getUploaderData()
  });
}

function uploadFromUrl(url, cancellationToken) {
  return new Promise((resolve, reject) => {
    var req = request
      .post(urlUploaderBaseUrl)
      .send({
        url: url,
        data: getUploaderData()
      })
      .end(function (error, res) {
        if (error) {
          reject(error);
        } else {
          resolve(toImage(JSON.parse(res.text)));
        }
      });

    if (cancellationToken) {
      cancellationToken.onCancelled(function (reason) {
        reject(reason);
        req.abort();
      });
    }
  });
}

var ImageUploader = {
  createFileUploader: createFileUploader,
  uploadFromUrl: uploadFromUrl
};

module.exports = ImageUploader;


/** WEBPACK FOOTER **
 ** ./utils/ImageUploader.js
 **/